<template>
<div>
 <v-card> 
   <v-toolbar light dense flat
  >
    <v-btn @click="$router.go(-1)" icon light>
      <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-toolbar-title>{{getTitle}}
    </v-toolbar-title>
  </v-toolbar>

  <v-card-text v-show="showDescription">
  <v-flex offset-xs10>
  <a @click="hideDescription()">
      скрыть
  </a>
  </v-flex>
  <v-flex>
  <div v-html="getDescriptionHtml">
  </div>
  </v-flex>
  </v-card-text>
  <v-card flat id="scroll_target" ref="scroll_target" class="scroll-y" :height="calcHeight()">
    <v-container px-2 pt-2
      v-scroll:#scroll_target="onScroll"
      fluid
      grid-list-lg
      style="min-height: 0; margin-top: 0"
    >
        <template v-for="item in getPosts">
          <v-flex :class="getOffsetClass(item)" xs11 pb-2>
            <v-card v-if="item.typeCode==='CHAT_INVITATION'" :color="getColor(item)">
             <v-card-text>
                <v-layout row>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>
            </v-card>
            <v-card v-if="item.typeCode==='PLAIN'" :color="getColor(item)">
              <v-card-text>
                <v-layout row>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>
            </v-card>
            <v-card v-if="item.typeCode==='OFFER'" :color="getColor(item)">
              <v-card-text>
                <v-layout row>
                  <v-flex >Оферта</v-flex>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>
 
             <v-card-actions>                
                <v-btn :disabled="!isAdmin()" v-show="partnerAction(item)" @click="changeActionState(item, 'SIGNED')">Акцепт</v-btn>
                <v-btn :disabled="!isAdmin()" v-show="partnerAction(item)" @click="changeActionState(item, 'REJECTED')">Отклонить</v-btn>
                <v-layout row>
                  <v-flex >{{resultText(item)}}</v-flex>
                  <v-flex  align-end v-html="getHTMLActionSign(item)"></v-flex>
                </v-layout>
              </v-card-actions>
              <v-card-actions>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="confirm(item)">Подтвердить</v-btn>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="rollback(item)">Отменить</v-btn>                
              </v-card-actions>
            </v-card>
            <v-card v-if="item.typeCode==='OFFER_CANCEL'" :color="getColor(item)">
               <v-card-text>
                <v-layout row>
                  <v-flex>Отмена оферты</v-flex>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>

             <v-card-actions>
              <v-layout row>
                <v-flex>{{resultText(item)}}</v-flex>
                <v-flex align-end v-html="getHTMLActionSign(item)"></v-flex>
              </v-layout>
             </v-card-actions>
             <v-card-actions>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="confirm(item)">Подтвердить</v-btn>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="rollback(item)">Отменить</v-btn>                
              </v-card-actions>
            </v-card>
            <v-card v-if="item.typeCode==='ACT'" :color="getColor(item)">
              <v-card-text>
                <v-layout row>
                  <v-flex>Акт/Накладная</v-flex>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>

             <v-card-actions>
                <v-btn :disabled="!isAdmin()" v-show="partnerAction(item)" @click="changeActionState(item, 'SIGNED')">Акцепт</v-btn>
                <v-btn :disabled="!isAdmin()" v-show="partnerAction(item)" @click="changeActionState(item, 'REJECTED')">Отклонить</v-btn>
                <v-layout row>
                  <v-flex>{{resultText(item)}}</v-flex>
                  <v-flex align-end v-html="getHTMLActionSign(item)"></v-flex>
                </v-layout>
             </v-card-actions>
             <v-card-actions>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="confirm(item)">Подтвердить</v-btn>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="rollback(item)">Отменить</v-btn>                
             </v-card-actions>
            </v-card>
            <v-card v-if="item.typeCode==='CLAIM'" :color="getColor(item)">
              <v-card-text>
                <v-layout row>
                  <v-flex>Претензия</v-flex>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>

             <v-card-actions>
                <v-layout row>
                <v-flex>{{resultText(item)}}</v-flex>
                <v-flex align-end v-html="getHTMLActionSign(item)"></v-flex>
                </v-layout>
             </v-card-actions>
             <v-card-actions>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="confirm(item)">Подтвердить</v-btn>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="rollback(item)">Отменить</v-btn>                
              </v-card-actions>             
            </v-card>

            <v-card v-if="item.typeCode==='OFFER_REQUEST'" :color="getColor(item)">
              <v-card-text>
                <v-layout row>
                  <v-flex>Запрос оферты / коммерческого предложения</v-flex>
                  <v-spacer></v-spacer>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>

             <v-card-actions>
                <v-layout row>
                <v-flex>{{resultText(item)}}</v-flex>
                <v-spacer></v-spacer>
                <v-flex align-end v-html="getHTMLActionSign(item)"></v-flex>
                </v-layout>
             </v-card-actions>
             <v-card-actions>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="confirm(item)">Подтвердить</v-btn>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="rollback(item)">Отменить</v-btn>                
              </v-card-actions>             
            </v-card>

            <v-card v-if="item.typeCode==='NOTIFY'" :color="getColor(item)">
              <v-card-text>
                <v-layout row>
                  <v-flex>Уведомление</v-flex>
                  <v-spacer></v-spacer>
                  <v-flex align-end v-html="getHTMLHeader(item)"></v-flex>
                </v-layout>
                <div v-html="getHTMLText(item)"></div>
              </v-card-text>

             <v-card-actions>
                <v-layout row>
                <v-flex>{{resultText(item)}}</v-flex>
                <v-flex align-end v-html="getHTMLActionSign(item)"></v-flex>
                </v-layout>
             </v-card-actions>
             <v-card-actions>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="confirm(item)">Подтвердить</v-btn>                
              <v-btn :disabled="!isAdmin()" v-show="item.state === 'NEW' || item.state === 'UPDATED'" @click="rollback(item)">Отменить</v-btn>                
              </v-card-actions>             
            </v-card>

          </v-flex>
        </template>
        </v-layout>
      </v-container>

  </v-card>
  <v-card-actions style="align-items: flex-end;">
    <v-btn icon light @click="dialogOpen('DOC_SELECTOR')">
      <v-icon>attach_file</v-icon>
    </v-btn>
       <v-textarea
        ref="focused"
        label="Введите текст"
        auto-grow
        rows="1"
        hint=""
        solo
        hide-details
        v-model="item.text"
      ></v-textarea>
    <v-btn icon light @click="addPost">
      <v-icon>send</v-icon>
    </v-btn>
    <v-menu left min-width='20rem'>
      <v-btn icon slot="activator" light>
        <v-icon>more_vert</v-icon>
      </v-btn>
      <v-list dense>
        <template v-for="item in this.getMenus">
        <v-divider v-if="item.divider"></v-divider>
        <v-list-tile v-else :key="item.title" @click="runAction(item)">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
        </template>
      </v-list>
    </v-menu>  
  </v-card-actions>
</v-card>

</div>
</template>
<script>
  import Vue from 'vue'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import dialogs from '../common/dialogs'
  import { mapGetters } from 'vuex'
  import vPostForm from './PostForm.vue'
  import vPostOfferForm from './PostOfferForm.vue'
  import vPostNotifyForm from './PostNotifyForm.vue'
  import vPostOfferCancelForm from './PostOfferCancelForm.vue'
  import vPostActForm from './PostActForm.vue'
  import vPostClaimForm from './PostClaimForm.vue'
  import vPostOfferRequestForm from './PostOfferRequestForm.vue'
  import depo from '../depo'
  import vConfirmDlg from './ConfirmDialog.vue'

  // import moment from 'moment'

  const SHOW_DESCRIPTION_ACTION = 'ADD_SPOT'
  const ADD_PLAIN_ACTION = 'ADD_PLAIN'
  const ADD_OFFER_ACTION = 'ADD_OFFER'
  const ADD_NOTIFY_ACTION = 'ADD_NOTIFY'
  const ADD_OFFER_CANCEL_ACTION = 'ADD_OFFER_CANCEL'
  const ADD_ACT_ACTION = 'ADD_ACT'
  const ADD_CLAIM_ACTION = 'ADD_CLAIM'
  const ADD_OFFER_REQUEST_ACTION = 'ADD_OFFER_REQUEST'
  const ALL_SCOPE_ACTION = 'ALL_SCOPE'
  const ACTIVE_SCOPE_ACTION = 'ACTIVE_SCOPE'
  const FAVORITE_SCOPE_ACTION = 'FAVORITE_SCOPE'

  export default {
    name: 'chat',
    data: () => ({
      menu: false,
      fileLink: null,
      showDescription: false,
      timer: '',
      rights: null,
      item: {
        text: '',
        link: ''
      },
      lastScrollHeight: 0,
      valid: false,
      menus: [
        {title: 'Поиск...'},
        {title: 'Информация о диалоге', action: SHOW_DESCRIPTION_ACTION},
        {divider: true},
        {title: 'Сообщение', action: ADD_PLAIN_ACTION},
        {title: 'Оферта', action: ADD_OFFER_ACTION, needRights: true},
        {title: 'Уведомление', action: ADD_NOTIFY_ACTION, needRights: true},
        {title: 'Акт/накладная', action: ADD_ACT_ACTION, needRights: true},
        {title: 'Претензия', action: ADD_CLAIM_ACTION, needRights: true},
        {title: 'Запрос оферты / коммерческого предложения', action: ADD_OFFER_REQUEST_ACTION, needRights: true},
        {title: 'Отмена оферты', action: ADD_OFFER_CANCEL_ACTION, needRights: true}
      ]

    }),
    props: {
      itemId: {
        type: String,
        default: null
      }
    },
    created () {
      this.fetchData(this.itemId)
    },
    watch: {
      itemId: function (newVal, oldVal) { // watch it
        this.fetchData(newVal)
      }
    },
    computed: {
      ...mapGetters({
        chatterChat: 'getChatterChat',
        chatterPosts: 'getChatterPosts',
        profile: 'getProfile',
        clientProfile: 'getClientProfile',
        getDepoUrl: 'getDepoUrl',
        getIsAllow: 'getIsAllow',
        calcScroll: 'calcScroll'
      }),
      getTitle () {
        var result = this.chatterChat && this.chatterChat.partnerName && !this.chatterChat.name ? this.chatterChat.partnerName : ''
        result = result + (result.length !== 0 && this.chatterChat.name ? ': ' : '')
        result = result + (this.chatterChat && this.chatterChat.name ? this.chatterChat.name : '')
        return result
      },
      getDescriptionHtml () {
        var partnerText = this.chatterChat && this.chatterChat.partnerName ? '<b>' + this.chatterChat.partnerName + '</b>, ИНН <b>' + this.chatterChat.partnerInn + '</b>' : ''
        var clientText = this.profile && this.profile.clientNameShort ? '<b>' + this.profile.clientNameShort + '</b>, ИНН <b>' + this.profile.clientInn + '</b>' : ''

        return '<div>' + partnerText + ' (белый фон)</div>  <div>' + clientText + ' (серый фон).</div>'
      },
      getPosts () {
        this.scrollBottom()
        return this.chatterPosts
      },
      getMenus () {
        return this.getIsAllow({POST_ACTION_CREATE: null}) ? this.menus : this.menus.filter(i => !i.needRights || i.needRights !== true)
      }
    },
    methods: {
      calcHeight () {
        var delta = 56 + 48
        delta = this.$refs.focused ? delta + this.$refs.focused.$el.offsetHeight + 16 : delta + 62 + 12
        return this.calcScroll(delta)
      },
      getOffsetClass (item) {
        // return this.profile.clientId === item.clientId ? 'offset-xs1' : ''
        return formats.compareString(this.profile.nameShort, item.accountName) === 0 ? 'offset-xs1' : ''
      },
      getColor (item) {
        return this.profile.clientId === item.clientId ? 'grey lighten-3' : 'white'
      },
      formatExpiryTime (dateTime) {
        if (dateTime) {
          return 'Действует по: ' + formats.formatDate(dateTime)
        }
        return ''
      },
      scrollBottom () {
        var self = this
        Vue.nextTick(function () {
          self.$refs.scroll_target.$el.scrollTop = self.$refs.scroll_target.$el.scrollHeight -
          self.lastScrollHeight
          self.lastScrollHeight = 0
        })
      },
      addItem (type) {
        this.dialogOpen(type)
      },
      runAction (item) {
        switch (item.action) {
          case SHOW_DESCRIPTION_ACTION:
            this.showDescription = true
            break
          case ADD_PLAIN_ACTION:
            this.addItem('PLAIN')
            break
          case ADD_OFFER_ACTION:
            this.addItem('OFFER')
            break
          case ADD_OFFER_CANCEL_ACTION:
            this.addItem('OFFER_CANCEL')
            break
          case ADD_ACT_ACTION:
            this.addItem('ACT')
            break
          case ADD_CLAIM_ACTION:
            this.addItem('CLAIM')
            break
          case ADD_OFFER_REQUEST_ACTION:
            this.addItem('OFFER_REQUEST')
            break
          case ADD_NOTIFY_ACTION:
            this.addItem('NOTIFY')
            break
          case ACTIVE_SCOPE_ACTION:
            break
          case ALL_SCOPE_ACTION:
            break
          case FAVORITE_SCOPE_ACTION:
            break
        }
      },
      changeActionState (item, newState) {
        this.$store.dispatch('setChatterPostAction', {item: item, action: {actionState: newState}})
      },
      getHTMLHeader (item) {
        var result = `${item.clientName}<br/>${item.accountName}<br/>${formats.formatDateTime(item.published)}`
        return result
      },
      getHTMLActionSign (item) {
        if (!item.actionState) {
          return null
        }
        switch (item.actionState) {
          case 'CANCELED':
          case 'REJECTED':
          case 'SIGNED': {
            return `${item.actionClientName}<br/>${item.actionAccountName}<br/>${this.formatActionTime(item)}`
          }
          case 'PUBLISHED':
          case 'EXPIRED': {
            return `${this.formatActionTime(item)}`
          }
        }
      },
      getHTMLText (item) {
        const addImg = (d) => {
          var depoUrl = this.getDepoUrl('')
          Array.from(d.getElementsByTagName('a')).forEach(a => {
            if (!a.href || !a.href.toString().startsWith(depoUrl)) {
              return
            }
            var n = a.cloneNode(false)
            var img = document.createElement('img')
            img.src = n.href + '/preview'
            img.alt = ''
            img.style = 'width:100%'
            n.appendChild(img)
            d.appendChild(n)
          })
        }

        var result = item.text.replace(/\n/g, '<br/>')
        var d = document.createElement('div')
        d.innerHTML = result
        addImg(d)
        return d.innerHTML
      },
      resultText (item) {
        if (!item.actionState) {
          return null
        }
        switch (item.actionState) {
          case 'CANCELED':
            return 'Запрос отменен '
          case 'REJECTED':
            if (item.typeCode === 'ACT') {
              return 'Работа не принята '
            }
            return 'Запрос отклонен '
          case 'SIGNED': {
            if (item.typeCode === 'OFFER') {
              return 'Оферта принята '
            }
            if (item.typeCode === 'ACT') {
              return 'Работа принята, замечаний нет '
            }
            return 'Запрос подписан '
          }
          case 'PUBLISHED': {
            if (item.typeCode === 'CLAIM') {
              return 'Претензия доставлена '
            }
            if (item.typeCode === 'NOTIFY') {
              return 'Уведомление доставлено '
            }
            if (item.typeCode === 'OFFER_REQUEST') {
              return 'Запрос доставлен '
            }
            if (item.typeCode === 'OFFER_CANCEL') {
              return 'Отмена оферты доставлена '
            }
            return 'Сообщение доставлено '
          }
          case 'EXPIRED':
            if (item.typeCode === 'OFFER') {
              return 'Срок действия оферты истек, оферта не принята.'
            }
            if (item.typeCode === 'ACT') {
              return 'Время принятия акта истекло.'
            }
            return 'Запрос устарел '
        }
      },
      partnerAction (item) {
        return item.actionState == null && this.profile.clientId !== item.clientId
      },
      clientAction (item) {
        return item.actionState == null && this.profile.clientId === item.clientId
      },
      formatActionTime (item) {
        return item.actionState == null ? this.formatExpiryTime(item.expiryTime) : formats.formatDateTime(item.actionTime)
      },
      hideDescription () {
        this.showDescription = false
      },
      addLink: function (value) {
        var docLink = this.getDepoUrl(value)
        this.item.text = this.item.text + `<a href="${docLink}">${docLink}</a>`
      },
      addPost () {
        if (this.item.text && this.item.text.length > 0) {
          var item = {}
          item.text = this.item.text
          item.chatId = this.chatterChat.id
          item.typeCode = 'PLAIN'
          this.$store.dispatch('addChatterPost', item)
          this.item.text = ''
        }
      },
      getActionCode (item) {
        return item.state === 'NEW' ? 'POST_ACTION_CREATE' : 'POST_ACTION_APPLY'
      },
      confirm (item) {
        var self = this
        const refresh = function (data) {
          self.fetchData(self.itemId)
        }
        var actionCode = this.getActionCode(item)
        dialogs.register('v-confirm-dlg', vConfirmDlg)
        var comp = {
          template: `
              <v-confirm-dlg :actionCode="actionCode" :resourceId="itemId" v-on:refresh="refresh" v-on:close="$emit('close')"></v-confirm-dlg>
          `,
          data () {
            return {
              actionCode: actionCode,
              itemId: item.id,
              refresh: refresh
            }
          }
        }
        dialogs.modal(comp)
      },
      rollback (item) {
        const cb = (data) => {
          this.fetchData(this.itemId)
        }
        const cbError = (e) => {
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при отмене действия '})
        }
        server.apiPost(
          '/api/me/action-rollbacks',
          {
            actionCode: this.getActionCode(item),
            resourceId: item.id
          },
          cb,
          cbError)
      },
      dialogOpen (type) {
        var comp = {}
        switch (type) {
          case 'DOC_SELECTOR':
            depo.selectDoc(this, this.addLink)
            return
          case 'PLAIN':
            dialogs.register('v-post-form', vPostForm)
            comp = { template: `
              <v-post-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-post-form>
            `}
            break
          case 'OFFER':
            dialogs.register('v-post-offer-form', vPostOfferForm)
            comp = { template: `
              <v-post-offer-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-post-offer-form>
            `}
            break
          case 'OFFER_CANCEL':
            dialogs.register('v-post-offer-cancel-form', vPostOfferCancelForm)
            comp = { template: `
              <v-post-offer-cancel-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-post-offer-cancel-form>
            `}
            break
          case 'ACT':
            dialogs.register('v-act-form', vPostActForm)
            comp = { template: `
              <v-act-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-act-form>
            `}
            break
          case 'CLAIM':
            dialogs.register('v-claim-form', vPostClaimForm)
            comp = { template: `
              <v-claim-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-claim-form>
            `}
            break
          case 'OFFER_REQUEST':
            dialogs.register('v-offer-request-form', vPostOfferRequestForm)
            comp = { template: `
              <v-offer-request-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-offer-request-form>
            `}
            break
          case 'NOTIFY':
            dialogs.register('v-notify-form', vPostNotifyForm)
            comp = { template: `
              <v-notify-form toolbar v-on:close="$emit('close')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-notify-form>
            `}
            break
        }
        dialogs.modal(comp)
      },
      isAdmin () {
        return this.getIsAllow({POST_ACTION_APPLY: null})
      },
      fetchRights () {
        this.$store.dispatch('fetchRights', {POST_ACTION_CREATE: null, POST_ACTION_APPLY: null})
      },
      fetchData (itemId) {
        if (itemId) {
          this.$store.dispatch('fetchChatterChat', itemId)
          this.$store.dispatch('fetchChatterChatPosts', {chatId: itemId, force: true})
          this.fetchRights('LOCAL_ADMIN_CHECK')
        }
      },
      onScroll (e) {
        if (e.target.scrollTop > 0) {
          return
        }
        if (this.itemId) {
          this.lastScrollHeight = e.target.scrollHeight
          this.$store.dispatch('fetchChatterChatPosts', {chatId: this.itemId, force: false})
        }
      }
    }
  }
</script>
<style>
.align-end{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// Chat.vue?045fee53